import {
  createAsyncThunk,
  createSlice,
  Draft,
  PayloadAction
} from "@reduxjs/toolkit";
import { HttpCodes } from "../../constants/app.constant";

import {
  getJobSearchList,
  getPrePopulatedSearches
} from "services/JobPricing/PrepopuldatedSearchesService";
import type { JobPricingSearchState } from "../../helpers/models/JobPricingSearchModels";
import { searchInitialState } from "./jobPricingSearchSlice";

export interface State {
  jobSearchResultList: any;
  isJobSearchDisabled: boolean;
  isJobSearchsLoading: boolean;
  selectedJobSearch: any;
  popularJobSearchs: any[];
  // isPopularJobSearchLoading: boolean;
  isPrePopulatedJobSearchesLoading: boolean;
  // prePopulatedJobSearches: any[];
  selectedPopularJobSearch: any;
  recentJobSearchs: any[];
  //isRecentJobSearchLoading: boolean;
  selectedRecentJobSearch: any;
  filtersList: any[];
  fileterPayloadMappings: JobPricingSearchState;
  selectedFiltersList: any[];
  selectedFiltersListWithKeyValue: any[];
  isFiltersLoading: boolean;
  isLandingSearchApiFailed: boolean;
  isSearchItemClicked: boolean;
}

const initialState: State = {
  jobSearchResultList: [],
  isJobSearchDisabled: false,
  isJobSearchsLoading: false,
  selectedJobSearch: {},
  popularJobSearchs: [],
  // isPopularJobSearchLoading: false,
  isPrePopulatedJobSearchesLoading: false,
  // prePopulatedJobSearches: [],
  selectedPopularJobSearch: {},
  recentJobSearchs: [],
  // isRecentJobSearchLoading: false,
  selectedRecentJobSearch: {},
  filtersList: [],
  fileterPayloadMappings: searchInitialState,
  selectedFiltersList: [],
  selectedFiltersListWithKeyValue: [],
  isFiltersLoading: false,
  isLandingSearchApiFailed: false,
  isSearchItemClicked: false
};

// pre-Populated Job searches thunk

export const PrepopulatedSearchesThunk = createAsyncThunk(
  "jobpricing/prepopulatedSearches",
  async (payload: any, thunkApi?: any) => {
    try {
      const { data } = await getPrePopulatedSearches(payload);
      if (data.responseCode == HttpCodes.SUCCESS) {
        return data.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);

      return thunkApi.rejectWithValue(e);
    }
  }
);

export const JobSearchListThunk = createAsyncThunk(
  "jobPricing/jobSearchList",
  async (payload: any, thunkApi?: any) => {
    try {
      const { key, _keyword } = payload;
      const { data } = await getJobSearchList(key, _keyword);
      if (data.responseCode == HttpCodes.SUCCESS) {
        return data.data || [];
      }
      return [];
    } catch (e) {
      console.log(e);

      return thunkApi.rejectWithValue(e);
    }
  }
);
export const jobSelectionSlice = createSlice({
  name: "jobpricing",
  initialState,
  reducers: {
    resetJobPricingState: () => initialState,
    resetJobSearch: (state: Draft<State>) => {
      return { ...state, clientsList: [], isClientsLoading: false };
    },
    setSearchItemClicked: (state, action) => {
      state.isSearchItemClicked = action.payload;
    },
    setSelectedJobSearch: (state: Draft<any>, action: PayloadAction) => {
      state.selectedClient = action.payload;
    },
    disableSearchField: (state: Draft<any>, action: PayloadAction) => {
      state.isJobSearchDisabled = true;
    },
    enableSearchField: (state: Draft<any>, action: PayloadAction) => {
      state.isJobSearchDisabled = false;
    },
    resetJobSearchList: (state: Draft<any>) => {
      state.jobSearchResultList = [];
    },
    setSelectedPopularJobSearch: (state: Draft<any>, action: PayloadAction) => {
      state.selectedPopularJobSearch = action.payload;
    },
    setSelectedRecentJobSearch: (state: Draft<any>, action: PayloadAction) => {
      state.selectedRecentJobSearch = action.payload;
    },
    setSelectedFiltersList: (state, action) => {
      state.selectedFiltersList = action.payload;
    },
    resetSelectedFiltersList: (state: Draft<any>) => {
      state.selectedFiltersList = [];
    },
    updateLandingSearchApiFailed: (state, action) => {
      state.isLandingSearchApiFailed = action.payload;
    },
    setSelectedFiltersListWithKeyValue: (state, action) => {
      return {
        ...state,
        ...state.selectedFiltersListWithKeyValue,
        selectedFiltersListWithKeyValue: action.payload
      };
    },
    getFiltersList: (state: Draft<any>) => {
      return { ...state, filtersList: initialState.filtersList };
    },
    resetPrepopulatedSearches: (state: Draft<any>) => {
      state.recentJobSearchs = [];
      state.popularJobSearchs = [];
    }
  },

  extraReducers: (builder) => {
    builder.addCase(JobSearchListThunk.pending, (state, action) => {
      state.isJobSearchsLoading = true;
      state.isLandingSearchApiFailed = false;
    });
    builder.addCase(JobSearchListThunk.fulfilled, (state, action) => {
      state.jobSearchResultList = action.payload;
      state.isJobSearchsLoading = false;
    });
    builder.addCase(JobSearchListThunk.rejected, (state, action) => {
      state.isJobSearchsLoading = false;
      state.jobSearchResultList = [];
      state.isLandingSearchApiFailed = true;
    });
    builder.addCase(PrepopulatedSearchesThunk.pending, (state, action) => {
      state.isPrePopulatedJobSearchesLoading = true;
      state.isLandingSearchApiFailed = false;
    });
    builder.addCase(PrepopulatedSearchesThunk.fulfilled, (state, action) => {
      const { popularSearch, recentSearch } = action.payload;
      state.popularJobSearchs = popularSearch;
      state.recentJobSearchs = recentSearch;
      state.isPrePopulatedJobSearchesLoading = false;
    });
    builder.addCase(PrepopulatedSearchesThunk.rejected, (state, action) => {
      state.isPrePopulatedJobSearchesLoading = false;
      state.popularJobSearchs = [];
      state.recentJobSearchs = [];
      state.isLandingSearchApiFailed = true;
    });
  }
});

export const {
  resetJobSearch,
  setSearchItemClicked,
  setSelectedJobSearch,
  setSelectedFiltersList,
  setSelectedFiltersListWithKeyValue,
  getFiltersList,
  resetJobSearchList,
  disableSearchField,
  enableSearchField,
  resetPrepopulatedSearches,
  resetSelectedFiltersList,
  updateLandingSearchApiFailed,
  resetJobPricingState
} = jobSelectionSlice.actions;

export default jobSelectionSlice.reducer;
